/**
 * Import packages
 */
import { createApp } from 'vue'
import Toast from "vue-toastification";
import "vue-toastification/dist/index.css";
import Modal from "vue-bs-modal";
import { useToast } from 'vue-toastification';

/**
 * Import
 */
import router from './router'
import store from './store'

/**
 * Import components
 */
import App from './App'
import PaperDashboard from "./plugins/paperDashboard";
import i18n from './translation';

/**
 * Import Font Awesome Icon
 */
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import { library } from "@fortawesome/fontawesome-svg-core";
import {
    faAngleDoubleDown,
    faAngleDoubleUp,
    faCopy,
    faXmark,
    faTrashCan,
    faLink,
    faGauge,
    faFileInvoice,
    faFileInvoiceDollar,
    faUnlock,
    faPlug,
    faMoneyBillTransfer,
    faWallet,
    faGear,
    faMoneyBillTrendUp,
    faPuzzlePiece,
    faSection,
    faEdit,
    faEye,
    faChevronUp,
    faChevronDown,
    faFileExcel,
    faCircleDollarToSlot,
    faEyeSlash
} from '@fortawesome/free-solid-svg-icons';

import {
    faUser as farFaUser,
    faBell as farFaBell,
    faEnvelope as farFaEnvelope,
    faCalendarDays as farFaCalendarDays,
    faIdBadge as farFaIdBadge
} from '@fortawesome/free-regular-svg-icons';


library.add(
    faAngleDoubleDown,
    faAngleDoubleUp,
    faTrashCan,
    faCopy,
    faXmark,
    faLink,
    faGauge,
    faFileInvoice,
    faFileInvoiceDollar,
    faUnlock,
    faPlug,
    faMoneyBillTransfer,
    faWallet,
    faGear,
    faMoneyBillTrendUp,
    faPuzzlePiece,
    faSection,
    faEdit,
    faEye,
    faEyeSlash,
    faChevronUp,
    faChevronDown,
    faFileExcel,
    faCircleDollarToSlot,
    farFaUser,
    farFaBell,
    farFaEnvelope,
    farFaCalendarDays,
    farFaIdBadge
);

/**
 * Create App
 */
const app = createApp(App);

app.config.globalProperties.COMPANY_NAME = process.env.VUE_APP_COMPANY_NAME;
app.config.globalProperties.COMPANY_URL = process.env.VUE_APP_COMPANY_URL;
app.config.globalProperties.API_URL = process.env.VUE_APP_API_PATH;
app.config.globalProperties.ACTIVE_CURRENCIES = process.env.VUE_APP_ACTIVE_CURRENCIES;
app.config.globalProperties.$toast = useToast();

app.config.globalProperties.$requestInterval = 15000;

app.config.errorHandler = (error) => {
    console.error('An error', error);
};

app.directive('focus', {
    mounted(el) {
        el.focus()
    }
})

app.component('fa-icon', FontAwesomeIcon)
    .use(store)
    .use(Modal)
    .use(Toast, {
        position: "top-right",
        timeout: 3000,
        closeOnClick: true,
        pauseOnFocusLoss: true,
        pauseOnHover: true,
        draggable: true,
        draggablePercent: 0.6,
        showCloseButtonOnHover: false,
        hideProgressBar: false,
        closeButton: "button",
        icon: true,
        rtl: false
    })
    .use(router)
    .use(i18n)
    .use(PaperDashboard)
    .mount('#app');
